import {AuthConfig} from 'angular-oauth2-oidc';
import { environment } from 'src/environments/environment';


export const authConfig: AuthConfig = {
issuer: 'https://login.microsoftonline.com/4f6e1565-c2c7-43cb-8a4c-0981d022ce20/v2.0',
redirectUri: window.location.origin,
clientId: environment.clientId,
scope: 'openid profile email',
requireHttps: false,
strictDiscoveryDocumentValidation: false
};
